export {default} from '../../../core/components/Repository/FieldTextDrilldown';